/**
 * Service Exception type to filter out user fault exceptions for Sentry logging
 */
export class UserFaultException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UserFaultException";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
